// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavDropdown_wrapper__1C9fd","menu":"NavDropdown_menu__1Oywj"};